import './tt.css';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function BlackJack() { 
    const navigate = useNavigate();
    const bjWS = process.env.PUBLIC_URL + '/blackjackWelScreen.PNG';
    const bjGame = process.env.PUBLIC_URL + '/blackjackGame.PNG';

    const [modalImage, setModalImage] = useState(null);

    const openModal = (image) => {
        setModalImage(image);
    };

    const closeModal = () => {
        setModalImage(null);
    };

    return(
        <div className="BlackJack">
            <div className="middle-column">
                <h1>BlackJack</h1>
                <h3>A simple game on a hard-for-no-reason language</h3>
                <p>This small project was made with the intention of pushing myself to make a simple game where all the edge cases matter the most using one of the most opinionated languages out there, JAVA.</p>
                <p>First, I created a very simple Welcome Screen that lets the user decide the starting amount of money for this instance. I wish every Casino did that.</p>
                <img src={bjWS} alt="bjWS" onClick={() => openModal(bjWS)} />
                <p>Then, after starting the game with a positive number of money, the user can decide the bet amount they want to bet each time. The game waits for the user to click on Bet to start.</p>
                <p>After the game starts, the user can see one dealer card and their 2 cards, then they can decide to Hit or Stand. The game is played with a single deck of cards and the dealer has to hit until they reach 17 or more. The user can play as many rounds as they want until they run out of money or they decide to leave the game.</p>
                <p>After each Stay click, an alert is shown to the user with information about last hand. The amount of money you won or lost, the Dealer's final hand and the user's hand when they decided to Stay.</p>
                <img src={bjGame} alt="bjGame" onClick={() => openModal(bjGame)} />
                <p>The game is very simple, but at the time of working on this project I was trying to learn a bit more about the JAVA language and JavaFX. The main purpose of small projects like these is to push yourself into learning more about languages and frameworks you are not familiar with.</p>
                <p>A simple git repository was created for this project and you can view it <a href="https://github.com/elson99/BlackJackJAVA" target="_blank" rel="noopener noreferrer">here</a>.</p>
                <button onClick={() => navigate('/')}>Back to Homepage</button>               
            </div>
            {modalImage && (
                <div className="modal" onClick={closeModal}>
                    <span className="close" onClick={closeModal}>&times;</span>
                    <img className="modal-content" src={modalImage} alt="Modal" />
                </div>
            )}
        </div>
    )
}

export default BlackJack;